/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
export type LotCurrency = "CHF" | "EUR" | "GBP";
import type { FragmentReference } from "relay-runtime";
declare export opaque type lotPricePerMeterSquared_product$ref: FragmentReference;
declare export opaque type lotPricePerMeterSquared_product$fragmentType: lotPricePerMeterSquared_product$ref;
export type lotPricePerMeterSquared_product = {|
  +currency: ?LotCurrency,
  +salePrice: ?number,
  +property: {|
    +livingSurface: ?number,
    +builtSurface: ?number,
    +weightedFloorSurface: ?number,
    +usableSurface: ?number,
  |},
  +$refType: lotPricePerMeterSquared_product$ref,
|};
export type lotPricePerMeterSquared_product$data = lotPricePerMeterSquared_product;
export type lotPricePerMeterSquared_product$key = {
  +$data?: lotPricePerMeterSquared_product$data,
  +$fragmentRefs: lotPricePerMeterSquared_product$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "lotPricePerMeterSquared_product",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "salePrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Property",
      "kind": "LinkedField",
      "name": "property",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "livingSurface",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "builtSurface",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "weightedFloorSurface",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "usableSurface",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '4b881b0a0c7624ea4f4684d35b62a269';

export default node;
